import { Button } from "@/components/ui/button";
import { Card } from "@/components/ui/card";
import { ArrowRight, CheckCircle2, MailCheck, Users } from "lucide-react";
import { useEffect, useState } from "react";

interface EnterpriseContactSuccessProps {
  onReset: () => void;
  onClose: () => void;
}

export const EnterpriseContactSuccess = ({ onReset, onClose }: EnterpriseContactSuccessProps) => {
  const [show, setShow] = useState(false);

  // Trigger animation after component mount
  useEffect(() => {
    const timer = setTimeout(() => {
      setShow(true);
    }, 10);

    return () => clearTimeout(timer);
  }, []);

  return (
    <div
      className={`w-full transition-all duration-500 ease-in-out ${
        show ? "opacity-100 translate-y-0" : "opacity-0 translate-y-4"
      }`}
    >
      <Card className="p-8 border-none shadow-none">
        <div className="flex flex-col items-center space-y-6 text-center">
          <div className="rounded-full bg-green-100 p-3 dark:bg-green-900/30">
            <MailCheck className="h-12 w-12 text-green-600 dark:text-green-400 animate-[pulse_2s_ease-in-out_infinite]" />
          </div>
          <div className="space-y-2">
            <h3 className="text-2xl font-semibold tracking-tight">Enterprise Inquiry Sent!</h3>
            <p className="text-muted-foreground">
              Thank you for your interest in our enterprise solutions. Our team will review your requirements and get
              back to you as soon as possible.
            </p>
          </div>
          <div className="flex gap-4">
            <Button className="mt-2" variant="outline" onClick={onReset}>
              Submit Another Inquiry
            </Button>
            <Button className="mt-2 group" variant="default" onClick={onClose}>
              Close
              <ArrowRight className="ml-2 h-4 w-4 transition-transform group-hover:translate-x-1" />
            </Button>
          </div>
        </div>
      </Card>
    </div>
  );
};
